// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".benefits__items__item__icon[data-v-eec042ac]{width:2.5rem;height:2.5rem;-o-object-fit:contain;object-fit:contain}.benefits__items__item h5[data-v-eec042ac]{color:#1f2430}.benefits__items__item p[data-v-eec042ac]{max-width:260px}.benefits__more[data-v-eec042ac]{margin-top:2rem;display:inline-block;font-weight:700;color:#443fdb!important;cursor:pointer}.benefits__more>i[data-v-eec042ac]{font-size:.7rem;margin-left:.3rem}", ""]);
// Exports
module.exports = exports;
